<div [class]="'gaugeGraph ' + fromStateGauge(stateGauge)">
    <div class="gaugeGraph-line">
        <span class="gaugeGraph-line-solid" [ngClass]="'pourcent-' + roundedValue"></span>
        <span class="gaugeGraph-line-label"><ng-content></ng-content></span>
    </div>
</div>
